module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-before-after"
  }, [_c('div', {
    staticClass: "custom-before-after__bg"
  }, [_c('div', {
    staticClass: "custom-before-after__container"
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointTitle,
        options: _vm.intersectionTitleOptions
      }),
      expression: "{ active: true, callback: onWaypointTitle, options: intersectionTitleOptions }"
    }],
    staticClass: "custom-before-after__title",
    class: {
      "custom-before-after__title--active": _vm.fadeTitle
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-before-after__gallery-container"
  }, _vm._l((_vm.props.patient), function(patient) {
    return _c('div', {
      staticClass: "custom-before-after__patient"
    }, [_c('div', {
      staticClass: "custom-before-after__patient--name",
      domProps: {
        "innerHTML": _vm._s(patient.name)
      }
    }), _c('div', {
      staticClass: "custom-before-after__col-left"
    }, [_c('image-compare', {
      staticClass: "custom-before-after__front-teeth",
      attrs: {
        "before": patient.left_after_image,
        "after": patient.left_before_image
      }
    }, [_c('Icon', {
      attrs: {
        "slot": "icon-left",
        "name": "LeftArrow",
        "aria-hidden": "true"
      },
      slot: "icon-left"
    }), _c('Icon', {
      attrs: {
        "slot": "icon-right",
        "name": "RightArrow",
        "aria-hidden": "true"
      },
      slot: "icon-right"
    })], 1)], 1), _c('div', {
      staticClass: "custom-before-after__col-right"
    }, [_c('image-compare', {
      staticClass: "custom-before-after__side-teeth",
      attrs: {
        "before": patient.right_after_image,
        "after": patient.right_before_image
      }
    }, [_c('Icon', {
      attrs: {
        "slot": "icon-left",
        "name": "LeftArrow",
        "aria-hidden": "true"
      },
      slot: "icon-left"
    }), _c('Icon', {
      attrs: {
        "slot": "icon-right",
        "name": "RightArrow",
        "aria-hidden": "true"
      },
      slot: "icon-right"
    })], 1)], 1)])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc8f9540","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-patients-before-after/custom-patients-before-after.pug
// module id = 598
// module chunks = 1